import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ArrowLeft, Settings2, Bot } from 'lucide-react';
import { useAgentStudioNavigate } from '../lib/routes';
import { Button } from '../components/ui/Button';
import { agentsService } from '../services/agentsService';
import { AgentChat } from '../features/agents/AgentChat';
import type { Agent } from '../types';

// Página dedicada ao chat de um agente. Acessada pelo card em /agents ("Entrar no chat").
// Mantém o atalho "Configurar" para abrir o editor do mesmo agente.
export function AgentChatPage() {
  const { id } = useParams();
  const navigate = useAgentStudioNavigate();
  const [agent, setAgent] = useState<Agent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    agentsService.get(id).then((a) => {
      setAgent(a ?? null);
      setLoading(false);
    });
  }, [id]);

  if (!id) return null;

  return (
    <div className="flex h-full min-h-0 flex-col">
      <header className="flex shrink-0 items-center justify-between gap-3 border-b border-line bg-white px-6 py-3">
        <div className="flex min-w-0 items-center gap-3">
          <Button variant="ghost" size="icon" icon={ArrowLeft} onClick={() => navigate('/agents')} aria-label="Voltar" />
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-orange text-white">
            <Bot className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <h1 className="truncate text-sm font-semibold text-ink">{loading ? 'Carregando…' : agent?.name ?? 'Agente'}</h1>
            <p className="text-xs text-slate">Chat do agente</p>
          </div>
        </div>
        <Button variant="secondary" icon={Settings2} onClick={() => navigate(`/agents/${id}`)}>
          Configurar
        </Button>
      </header>
      <div className="min-h-0 flex-1">
        <AgentChat agentId={id} />
      </div>
    </div>
  );
}
